const INTEREST_P_A = 0.025;
const PERCENTAGE_OF_CREDIT = 0.9;
const TAX = 0.04;

const DTI_LIMIT = 8;
const DSTI_LIMIT = 0.4; // 40%

export function getInterestPM() {
	return INTEREST_P_A / 12;
}

export function getMonthlyPayment(loan, months) {
	const quotient = 1 + getInterestPM();
	const result =
		(loan * (quotient - 1) * Math.pow(quotient, months)) / (Math.pow(quotient, months) - 1);

	return Math.ceil(result);
}

export function calcRatio(input, income) {
	return input / (12 * income);
}

export function isEntitlement(totalDebt, totalPayment, income, minIncome) {
	const dti = calcRatio(totalDebt, income);
	const dsti = calcRatio(totalPayment, income);

	const result = dti <= DTI_LIMIT && dsti <= DSTI_LIMIT && income > minIncome;
	return result;
}

export function getMaxPrice(income, payment, months) {
	const quotient = 1 + getInterestPM();
	const maxPayment = Math.max(income * 0.45 - payment, 0);
	const maxPrice =
		(maxPayment * (Math.pow(quotient, months) - 1)) / (Math.pow(quotient, months) * (quotient - 1));

	return Math.ceil(maxPrice);
}

export default function({ price, years, income, payment, debt }) {
	const loan = price * PERCENTAGE_OF_CREDIT;
	const months = years * 12;

	const monthlyPayment = getMonthlyPayment(loan, months);

	const ownResources = Math.ceil(price * (1 - PERCENTAGE_OF_CREDIT));
	const tax = Math.ceil(price * TAX);

	const minIncome = Math.ceil((monthlyPayment + payment) / 0.45);
	const maxPrice = getMaxPrice(income, payment, months);

	const entitlement = isEntitlement(loan + debt, monthlyPayment + payment, income, minIncome);

	return {
		ownResources,
		tax,
		monthlyPayment,
		minIncome,
		maxPrice,
		entitlement,
	};
}
